import React, { useState ,useEffect} from "react";
import "./SignupPage.css";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import API from "../utils/axiosInstance";
import { useTranslation } from "react-i18next";
import LanguageTranslation from "../components/languageTranslation"; // ✅ Import language switcher
import i18n from "../../src/config/i18n"; // ✅ Import i18n for language direction

const LoginPage = ({ lang }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation(); // ✅ initialize translation

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await API.post("/users/login", { email, password });
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    }
  };
    useEffect(() => {
    if (lang) i18n.changeLanguage(lang); // force the correct language
  }, [lang, i18n]);

  return (
    <div className="page-wrapper">
      {/* ✅ Top Bar with Logo & Language Switcher */}
      <div className="top-bar">
        <img src="/logo.svg" alt="Logo" className="logo-bar" />
        <LanguageTranslation className="lang-dropdown" /> {/* ✅ Added Dropdown */}
      </div>

      <div className="signup-container">
        <div className="signup-form">
          <h2>{t("WelcomeBack")}</h2>

          <form onSubmit={handleLogin}>
            <div className="input-group">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                placeholder={t("EnterEmail")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <FaLock className="input-icon" />
              <input
                type="password"
                placeholder={t("EnterPassword")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="signup-btn">
              {t("Login")}
            </button>
          </form>

          {/* Footer Links */}
          <div className="login-footer-links">
            <Link to="/forgot-password" className="forgot-link">
              {t("ForgotPassword")}
            </Link>
            <span className="divider">|</span>
            <span>
              {t("DontHaveAccount")}{" "}
              <Link to="/signup" className="signin-link">
                {t("SignUp")}
              </Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
